import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { useUser } from "@/apis/bff"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { AgentFilter } from "@/modules/waiting-room/components/appointment-filters/agent-filter"
import { AvailableToMeFilter } from "@/modules/waiting-room/components/appointment-filters/available-to-me-filter"
import { ChannelsFilter } from "@/modules/waiting-room/components/appointment-filters/channels-filter"
import { DateRangeFilter } from "@/modules/waiting-room/components/appointment-filters/date-range-filter"
import { LanguagesFilter } from "@/modules/waiting-room/components/appointment-filters/languages-filter"
import { ReviewNeededFilter } from "@/modules/waiting-room/components/appointment-filters/review-needed-filter"
import { ServicesFilter } from "@/modules/waiting-room/components/appointment-filters/services-filter"
import { SpecialtiesFilter } from "@/modules/waiting-room/components/appointment-filters/specialties-filter"
import { StatusFilter } from "@/modules/waiting-room/components/appointment-filters/status-filter"
import {
  useWaitingRoomFilters,
  useWaitingRoomFiltersContext,
} from "@/modules/waiting-room/contexts/waiting-room-filters-context"

const AppointmentFilters = () => {
  const { t } = useTranslation()
  const { hasFilters } = useWaitingRoomFilters()
  const user = useUser()
  const resetFilters = useWaitingRoomFiltersContext((state) => state.resetFilters)

  return (
    <div className="flex w-full flex-wrap items-center gap-2" data-testid="appointment-filters">
      <AvailableToMeFilter />
      <AgentFilter data-testid="agent-filter" />
      <LanguagesFilter />
      <ChannelsFilter />
      <Suspense>
        <ServicesFilter />
      </Suspense>
      <SpecialtiesFilter />
      <DateRangeFilter data-testid="date-range-filter" />
      <StatusFilter />
      {user.isOneOf(["MedicalSupervisor"]) && <ReviewNeededFilter data-testid="review-needed-filter" />}
      <Button
        variant="secondary"
        data-testid="appointment-clear-filter"
        className={cn(
          "text-primary border-none bg-transparent px-2 py-0",
          !hasFilters && "text-on-surface-disabled pointer-events-none",
        )}
        onClick={resetFilters}>
        {t("common.button.clearFilters")}
      </Button>
    </div>
  )
}

AppointmentFilters.displayName = "AppointmentFilters"

export { AppointmentFilters }
